module.exports = __webpack_public_path__ + "static/media/ic_remove_hovered.f0f78154.svg";